import React from "react";
import Routes from "./Routes";
import AnimationProvider from "./components/AnimationProvider";

function App() {
  return (
    <AnimationProvider>
      <Routes />
    </AnimationProvider>
  );
}

export default App;
